import React, { useState } from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import SideBar from './SideBar';
import MapBox from './MapBox';
import theme from './Theme';
import { calculateDensities } from './utils';

function App() {
  // TODO get these from sheetInputs.json
  const [formData, setFormData] = useState({
    'Location': {
      'Selected Lots': []
    },
    'Existing dwellings' : {
      'Number of existing houses on site': 0
    },
    Subdivision: {
      'Number of Proposed Lots': 2
    },
    'Dwelling density': {
      'Area of land in Very Low Density Residential (10 dw/ha)': 0,
      'Area of land in Lower Density Residential (15 dw/ha)': 0,
      'Area of land in Low Density Residential (20 dw/ha)': 0,
      'Area of land in R3 Medium Density Residential (25 dw/ha)': 0,
    }
  });

  // TODO duplicated in MapBox
  const removeLot = lot => {
    const newSelection = formData['Location'][
      'Selected Lots'
    ].filter(s => s.properties.GlobalID !== lot.properties.GlobalID);
    
    const densityAreas = calculateDensities(newSelection);
    //Update state
    setFormData({
      ...formData,
      'Location': {
        ...formData['Location'],
        'Selected Lots': newSelection
      },
      'Dwelling density': {
        ...formData['Dwelling density'],
        'Area of land in Very Low Density Residential (10 dw/ha)':
          densityAreas['10'],
        'Area of land in Lower Density Residential (15 dw/ha)':
          densityAreas['15'],
        'Area of land in Low Density Residential (20 dw/ha)':
          densityAreas['20'],
        'Area of land in R3 Medium Density Residential (25 dw/ha)':
          densityAreas['25']
      }
    });
  };

  return (
    <MuiThemeProvider theme={theme}>
      <div className='App'>
        <SideBar
          formData={formData}
          setFormData={setFormData}
          removeLot={removeLot}
        />
        <MapBox formData={formData} setFormData={setFormData} />
      </div>
    </MuiThemeProvider>
  );
}

export default App;
